// @flow
import type { Node } from 'react';
import React from 'react';

import styles from './activeIcon.css';

const ActiveIcon = () => (
  <div className={styles.outer1}>
    <div className={styles.inner1} />
  </div>
);

export default ActiveIcon;



// WEBPACK FOOTER //
// ./src/scripts/components/ActiveIcon/index.jsx